// extracted by mini-css-extract-plugin
export var body = "_m4-0";
export var sectionHeader = "_m4-4";
export var shortcutColumns = "_m4-2";
export var shortcutList = "_m4-1";
export var shortcutSection = "_m4-3";